import { Checkbox, Field } from '@fluentui/react-components';
import { ClientTag } from '../../../models/enums';

const options: Array<{ label: string; value: ClientTag }> = [
  { label: 'CSP', value: ClientTag.CSP },
  { label: 'Enterprise', value: ClientTag.Enterprise },
  { label: 'SMB', value: ClientTag.SMB },
  { label: 'Education', value: ClientTag.Education },
  { label: 'Government', value: ClientTag.Government },
  { label: 'Partner', value: ClientTag.Partner },
  { label: 'VIP', value: ClientTag.VIP },
];

export const ClientTags = ({ value, onChange }: { value: ClientTag[]; onChange: (value: ClientTag[]) => void }) => (
  <Field label="Tags">
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 8 }}>
      {options.map((option) => (
        <Checkbox
          key={option.value}
          label={option.label}
          checked={value.includes(option.value)}
          onChange={(_, data) => onChange(data.checked ? [...value, option.value] : value.filter((item) => item !== option.value))}
        />
      ))}
    </div>
  </Field>
);
